import { Input, Tag } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useState } from "react";
import { getBlueprintConfigApi } from "../../../../api/candidate";
import WebUtils from "../../../../utils/WebUtils";
import SelectedBlueprintForm from "../SelectedBlueprintForm";

function IDronaConfig({
  userDetail,
  iDronaId,
  setLoading,
  jdDetails,
  jdId,
  interviewState,
}) {
  const [configData, setConfigData] = useState(null);
  const [disableEdit, setDisableEdit] = useState(true);
  const formatDisplayDate = (dateString) => {
    if (!dateString) {
      return null;
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const getConfigData = (id, name, type) => {
    const url = `${getBlueprintConfigApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }&iDronaInterviewId=${iDronaId}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          // console.log(result.data.data);
          setConfigData(result.data.data);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "not_found"
        ) {
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getConfigData();
  }, []);

  return (
    <div className="mb-2 max-w-[1100px] mx-auto">
      {configData?.blueprintVariables ? (
        <>
          <SelectedBlueprintForm
            disableEdit={disableEdit}
            setDisableEdit={setDisableEdit}
            selectedAutoFillData={configData}
            jdDetails={jdDetails}
            userDetail={userDetail}
            jdId={jdId}
            iDronaId={iDronaId}
            setLoading={setLoading}
            iDronaConfigFlag={interviewState === "CONFIGURED" && true}
            noBackButton={true}
          />
          {/* <div className="border-2 px-3 py-0 shadow rounded-xl w-full ">
            <div className="mb-2 flex md:flex-row flex-col ">
              <div className="md:w-1/2 p-3">
                <div className="flex gap-3 gap-y-2 w-full sm:flex-row flex-col mt-3">
                  <div className="sm:w-1/2 w-full">
                    <p className="text-gray-600 mb-1">Job description title</p>
                    <Input
                      readOnly
                      value={configData?.blueprintVariables?.jobTitle}
                      className=" gray-opacity py-[.48rem] rounded-[8px]"
                    />
                  </div>
                  <div className="sm:w-1/2 w-full">
                    <p className="text-gray-600 mb-1">Company</p>
                    <Input
                      readOnly
                      value={configData?.blueprintVariables?.company}
                      className=" gray-opacity py-[.48rem] rounded-[8px]"
                    />
                  </div>
                </div>
                <div className="flex gap-x-3 gap-y-2 w-full sm:flex-row flex-col mt-3">
                  <div className="sm:w-1/2 w-full">
                    <p className="text-gray-600 mb-1">Interview duration</p>
                    <Input
                      readOnly
                      value={
                        configData?.blueprintVariables?.interviewDuration
                          ? configData?.blueprintVariables?.interviewDuration /
                              60 +
                            " min"
                          : null
                      }
                      className="py-[.48rem] rounded-[8px] gray-opacity"
                    />
                  </div>
                  <div className="sm:w-1/2 w-full">
                    <p className="text-gray-600 mb-1">Years of experience</p>
                    <Input
                      readOnly
                      value={configData?.blueprintVariables?.yearsOfExperience}
                      className="py-[.48rem] rounded-[8px] gray-opacity"
                    />
                  </div>
                </div>
                <div className="mt-3 flex sm:flex-row flex-col gap-x-3 gap-y-2">
                  <div className="sm:w-1/2 w-full">
                    <p className="text-gray-600 mb-1">User language</p>
                    <Input
                      readOnly
                      value={
                        configData?.blueprintVariables?.userLanguage?.language +
                          "(" +
                          configData?.blueprintVariables?.userLanguage
                            ?.languageCode +
                          ")" || ""
                      }
                      className="py-[.48rem] rounded-[8px] gray-opacity"
                    />
                  </div>
                  <div className="sm:w-1/2 w-full">
                    <p className="text-gray-600 mb-1">Bot language</p>
                    <Input
                      readOnly
                      value={
                        configData?.blueprintVariables?.botLanguage?.language +
                          "(" +
                          configData?.blueprintVariables?.botLanguage
                            ?.languageCode +
                          ")" || ""
                      }
                      className="py-[.48rem] rounded-[8px] gray-opacity"
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <p className="text-gray-600 mb-1">Requirements</p>
                  <TextArea
                    style={{
                      height: 133,
                      resize: "none",
                      whiteSpace: "pre-line",
                    }}
                    readOnly
                    value={configData?.blueprintVariables?.jobRequirements}
                    className="rounded orange-scroll gray-opacity"
                  />
                </div>
              </div>
              <div className="md:w-1/2 p-3">
                <div className="">
                  <p className="text-gray-600 mb-1">Responsibilities</p>
                  <TextArea
                    style={{
                      height: 133,
                      resize: "none",
                      whiteSpace: "pre-line",
                    }}
                    readOnly
                    value={configData?.blueprintVariables?.jobResponsibilities}
                    className="rounded orange-scroll gray-opacity"
                  />
                </div>
                <div className="mt-5">
                  <p className="text-gray-600 mb-1">Skills</p>
                  <div>
                    {configData?.blueprintVariables?.skillsList?.map(
                      (item, index) => (
                        <Tag
                          key={index}
                          color="geekblue"
                          className="rounded mb-2 mr-2 p-1 gray-opacity"
                        >
                          {item.skillName}-{item.skillWeightage}%
                        </Tag>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </>
      ) : (
        <div className="mx-auto  text-gray-500 font-medium text-[1.05rem]">
          <div className="mx-auto flex justify-center items-center">
            {/* <img src={emptySvg} alt="" /> */}
          </div>
          <div className="text-center">Invalid iDrona ID.</div>
          {/* <div className="text-center">
            Please reach out to your Account Manager to enable and use this
            Maya.
          </div> */}
        </div>
      )}
    </div>
  );
}

export default IDronaConfig;
